/**
 * Helper functions for content stream reducer logic.
 * Handles creation and management of content stream message entities.
 * Each unique event_id represents a separate content stream (e.g., from different agents).
 */

import { insertStreamingEntityAfterParent } from './chat-entity-insertion.helper'
import type { CreateContentStreamEntityPayload } from './chat-message-entity.interface'
import type { ChatState } from './chat-state.interface'

export const handleCreateContentStreamEntity = (
  state: ChatState,
  payload: CreateContentStreamEntityPayload
): void => {
  insertStreamingEntityAfterParent(state, {
    conversationId: payload.conversationId,
    parentEventId: payload.parentEventId,
    eventId: payload.eventId,
    agentName: payload.agentName,
    threadId: payload.threadId,
    messageRunId: payload.messageRunId,
    turnStartedAt: payload.turnStartedAt,
    agentLabel: payload.agentLabel,
    parentThreadId: payload.parentThreadId,
  })
}
